import React, {
  ReactElement, ReactNode, useCallback, useLayoutEffect, useMemo, useState,
} from 'react';
import { useLocation } from 'react-router';
import ErrorMessageContext, { ErrorMessageContextType } from './ErrorMessageContext';
import { useClientStatusContext } from '../../ClientStatusContext';

interface Props {
  children: ReactNode;
}

const ErrorMessageContextProvider = ({ children }: Props): ReactElement => {
  const [messages, setMessages] = useState<Array<string>>([]);
  const [displayed, setDisplayed] = useState(false);
  const currentLocation = useLocation();
  const { clearStatus } = useClientStatusContext();

  useLayoutEffect(() => {
    setDisplayed(true);
  }, [currentLocation.pathname, currentLocation.search]);

  useLayoutEffect(() => {
    if (displayed) {
      setMessages([]);
    }
  }, [displayed]);

  const displayError = useCallback((text: string): void => {
    if (clearStatus) {
      clearStatus();
    }
    setMessages([text]);
    setDisplayed(false);
  }, [clearStatus]);

  const clearMessages = (): void => {
    setMessages([]);
  };

  const value: ErrorMessageContextType = useMemo(() => ({
    messages,
    displayError: text => displayError(text),
    clearMessages,
  }), [displayError, messages]);

  return (
    <ErrorMessageContext.Provider value={value}>
      {children}
    </ErrorMessageContext.Provider>
  );
};

export default ErrorMessageContextProvider;
